<template>
  <div class="firm_container">
    <div class="firm_Main_body">
      <!-- 头部导航栏 -->
      <div class="Navigation_con1">
        <NavFirm :navNum="1" @handleWarn="handleWarn"></NavFirm>
      </div>
      <div class="firm-nav-table">
        <div class="nav-left">
          <div class="menu-box">
            <div class="menu-title" @click="goBack">
              <img
                class="title-img"
                src="@/assets/imgs/back-da@3x.svg"
                alt=""
              />
              <span class="title-text">返回首页</span>
            </div>
            <div
              v-for="(item, index) in filteredMenuList"
              :key="item.id"
              @click="routerChange(index, item)"
              :class="
                selIndex === index ? 'menu-box-item-no' : 'menu-box-item-yes'
              "
            >
              {{ item.name }}
            </div>
          </div>
        </div>
        <div class="nav-right">
          <div
            style="
              width: 1200px;
              min-height: calc(100vh - 60px);
              margin: 0 auto;
              padding-top: 30px;
              box-sizing: border-box;
            "
          >
            <router-view></router-view>
          </div>
          <!-- 账号注销提示弹窗 -->
          <SignOut
            :dialogSignOut="dialogSignOut"
            @handleClose="handleClose"
            @handleUnderstand="handleUnderstand"
          >
          </SignOut>
        </div>
      </div>

      <!-- 右侧反馈   客服 -->
      <!-- <div class="right_btn">
            <IndexRight></IndexRight>
          </div> -->
    </div>
  </div>
</template>

<script>
// 账号注销提示弹窗
import SignOut from "../../personage/home/components/Popup/SignOut.vue";
// 反馈 客服
import IndexRight from "../../../components/IndexRight.vue";
import NavFirm from "../../../components/NavFirm.vue";
export default {
  props: {},
  // 局部注册的组件
  components: {
    NavFirm,
    //IndexRight,
    SignOut,
  },
  // 组件状态值
  data() {
    return {
      scroll: "",
      scrollType: "1",
      searchType: "",
      dialogSignOut: false, // 账号注销弹窗开启关闭
      // 原始菜单配置
      menuList: [
        {
          name: "员工管理",
          url: "/Firm/talentStaff",
          id: 1,
          val: ["company:employee:manage", "company:dept:manage"],
        },
        {
          name: "文件库管理",
          url: "/Firm/talentFile",
          id: 2,
          val: ["company:filelib:manage"],
        },
        {
          name: "资料下载",
          url: "/Firm/talentInformation",
          id: 3,
          val: ["company:file:download"],
        },
        {
          name: "回收站",
          url: "/Firm/talentRecycle",
          id: 4,
          val: ["company:employee:recycle"],
        },
      ],
      // 过滤后的菜单（页面渲染用这个）
      filteredMenuList: [],
      selIndex: 0,
    };
  },
  watch: {
    scroll: {
      handler(newss, old) {
        if (newss > 80) {
          this.scrollType = "2";
        } else {
          this.scrollType = "1";
        }
      },
      immediate: false,
    },
    // 监听页面路径 → 自动匹配高亮
    $route(newVal) {
      this.updateSelIndexByPath(newVal.path);
    },
  },
  // 组件初始化
  created() {
    this.$bus &&
      this.$bus.$on("admin-permission-updated", this.onAdminPermissionUpdated);
  },
  mounted() {
    this.$nextTick(() => {
      this.filterMenuByPermission(); // 1. 先过滤
      this.updateSelIndexByPath(this.$route.path); // 2. 再匹配高亮
    });
    window.addEventListener("scroll", this.handleScroll, true);
  },
  beforeDestroy() {
    this.$bus &&
      this.$bus.$off("admin-permission-updated", this.onAdminPermissionUpdated);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  // 组件方法
  methods: {
    onAdminPermissionUpdated() {
      this.filterMenuByPermission();
      this.updateSelIndexByPath(this.$route.path);
    },
    // 打开账号注销弹窗
    handleWarn() {
      this.dialogSignOut = true;
    },
    // 点击取消x 关闭账号注销提示弹窗
    handleClose() {
      this.dialogSignOut = !this.dialogSignOut;
    },
    // 账号注销弹窗 点击确认
    handleUnderstand() {
      this.dialogSignOut = !this.dialogSignOut;
      // 账号确认注销，关闭弹窗返回登录页
      this.$router.push("/login");
    },
    //返回首页
    goBack() {
      this.$router.push({
        path: "/FirmHomePage",
      });
    },
    // 获取页面卷动高度
    handleScroll() {
      this.scroll =
        document.documentElement.scrollTop || document.body.scrollTop;
    },
    routerChange(index, item) {
      this.selIndex = index;
      this.$router.push({
        path: item.url,
      });
    },

    filterMenuByPermission() {
      let permissionCodes = localStorage.getItem("permissionCodes");
      permissionCodes = permissionCodes ? JSON.parse(permissionCodes) : [];

      // 权限判断
      const hasEmployeeManage = permissionCodes.includes("company:employee:manage");
      const hasDeptManage = permissionCodes.includes("company:dept:manage");

      this.filteredMenuList = this.menuList.filter((item) => {
        if (!item.val || item.val.length === 0) return true;
        return item.val.some((code) => permissionCodes.includes(code));
      }).map(item => {
        // 员工菜单特殊处理
        if (item.id === 1) {
          // 有员工管理权限 → 正常页面
          if (hasEmployeeManage) {
            return { ...item, url: "/Firm/talentStaff" };
          }
          // 没有员工管理，但有部门管理 → 跳设置页
          else if (hasDeptManage) {
            return { ...item, url: "/Firm/talentStaff/setting" };
          }
        }
        return item;
      });

      // 过滤后，检查当前路由是否有效
      const currentPath = this.$route.path;
      const isPathValid = this.filteredMenuList.some((item) =>
        currentPath.startsWith(item.url)
      );

      if (!isPathValid && this.filteredMenuList.length > 0) {
        const firstMenu = this.filteredMenuList[0];
        // 延迟执行，避免与路由守卫冲突
        setTimeout(() => {
          this.$router.replace({ path: firstMenu.url });
        }, 100);
        this.selIndex = 0;
      }
    },

    updateSelIndexByPath(path) {
      if (this.filteredMenuList.length === 0) return;

      const index = this.filteredMenuList.findIndex((item) => {
        return path.startsWith(item.url);
      });

      if (index !== -1) {
        this.selIndex = index;
      } else {
        // 找不到就默认第一个
        this.selIndex = 0;
        // 同时跳转（保险）
        // 延迟执行，避免与路由守卫冲突
        setTimeout(() => {
          this.$router.replace({ path: this.filteredMenuList[0].url });
        }, 100);
      }
    },
  },
};
</script>
<style scoped lang="less">
@import "../../../assets/css/firmEachIndex.css";

.firm_container {
  .firm_Main_body {
    .firm-nav-table {
      display: flex;

      .nav-left {
        width: 200px;
        padding: 10px 0px;
        font-size: 18px;
        font-family: PingFangSC-Medium;
        color: #333;
        box-sizing: border-box;
        background-color: #fff;

        .menu-box {
          .menu-title {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 50px;
            background: rgba(97, 144, 232, 0.3);
            border-radius: 10px;
            font-size: 20px;
            color: #409eff ;
            margin: 10px 10px 20px;
            cursor: pointer;

            .title-img {
              margin: 2px 10px 0 0;
            }
            .title-text {
              font-size: 20px;
            }
          }

          .menu-box-item-yes {
            width: 180px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            background: #fff;
            border-radius: 5px;
            font-size: 16px;
            margin: 8px 10px;
            cursor: pointer;
            color: #333;
          }

          .menu-box-item-no {
            width: 180px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            background: #eeeeee;
            border-radius: 5px;
            font-size: 16px;
            cursor: pointer;
            margin: 8px 10px;
            color: #409eff ;
          }
        }
      }

      .nav-right {
        flex: 1;
        background: rgba(97, 144, 232, 0.1);
        border-radius: 50px 0px 0px 50px;
      }
    }
  }
}
/deep/.el-input__inner {
  border: 1px solid #409eff  !important ;
}
</style>
